import { createContext } from "react";

const BlobCountContext = createContext({});

export default BlobCountContext;